import ApiClient from './apiClient'
import { GetTimeLineParams, getActionsResponse, getSchedulerResponse, getTimesResponse } from '../types/timeline'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getActions = async (params: GetTimeLineParams): Promise<any> => ApiClient.get(
  '/api/v1/features/timeline/action',
  (result: getActionsResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTimes = async (params: GetTimeLineParams): Promise<any> => ApiClient.get(
  '/api/v1/renderer/timeline/time',
  (result: getTimesResponse) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getScheduler = async (params: GetTimeLineParams): Promise<any> => ApiClient.get(
  '/api/v1/features/timeline/schedule',
  (result: getSchedulerResponse) => result,
  params,
)
